export const generateStartupIdea = async () => {
  const response = await fetch('https://api.openai.com/v1/chat/completions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
    },
    body: JSON.stringify({
      model: 'gpt-4',
      messages: [
        {
          role: 'system',
          content: 'You are a deranged crypto startup idea generator fueled by the fever dreams of crypto Twitter, rug pulls, memecoin manias, and dystopian DeFi scams. Generate 5 startup ideas that are absurd, unethical, or doomed but feel plausible enough to go viral on crypto Twitter. Each idea must be: One short, punchy sentence, Raw, deadpan, or maniacally overconfident, Inspired by crypto culture (memecoins, DAOs, NFTs, AI, etc). Examples: A DAO that bribes KOLs to spread FUD about rival memecoins. A social network where every post is a token and can be speculated on. A ponzi-powered fitness app that liquidates you if you miss leg day. No emojis, hashtags, disclaimers, or fluff. Just drop the ideas like tweets from a unhinged founder. Lean in to degeneracy, hard. Do not over-explain, the shorter the better.'
        },
        {
          role: 'user',
          content: 'Give me one startup idea. Follow the format and tone above. No run-ons. No emojis.',
        },
      ],
      temperature: 1.2,
      max_tokens: 100,
    }),
  });

  if (!response.ok) {
    console.error(await response.text());
    throw new Error('Failed to fetch idea');
  }

  const data = await response.json();
  return data.choices?.[0]?.message?.content?.trim() || 'No idea returned';
};
